import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withTheme } from 'styled-components'
import { upperFirst } from 'lodash';
import { message, Select } from 'antd'

// Components
import { Button, TextButton } from '../../Reusable/Button'
import { Text } from '../../Reusable/Text'
import { Image } from '../../Reusable/Image'
import { FlexColumn, Flex } from '../../Reusable/Container'
import { LabeledInput } from '../../Reusable/Input'
import { ErrorAlert } from '../../Reusable/Alert'
import environment from '../../../environment'
import { FromAccountOption } from '../../Reusable/Option'
import { apiPOSTReq } from '../../../Utils/api'
import { addressObjectToStr, getFeaturePerm, getBPAccountsWithAccess } from '../../../Utils/util'
import SearchBanks from '../../Banking/Recipients/SearchBanks'
import SearchRTPBanks from '../../Banking/Recipients/SearchRTPBanks'
import AionIcon from '../../../Images/aion-bank-icon.png'
import AionBankIcon from '../../../Images/aion-shadow.png'
import BofAIcon from '../../../Images/bofa-icon.png'
import ChaseIcon from '../../../Images/chase-icon.png'
import Search from '../../../Images/icon-search.svg'
import { LoadingOutlined } from '@ant-design/icons';

const { Option } = Select

class AddPaymentMethod extends Component {

    constructor(props) {
        super(props)

        var fromAccount

        if (this.props.pm && this.props.pm.accountId) {
            const Accounts = getBPAccountsWithAccess(null, { resourceStr: "Payables.Vendors", permType: "manage", getActiveAccounts: true })
            fromAccount = Accounts.find(account => account.accountId === this.props.pm.accountId)
        }

        var instantPaymentsEnabled = getFeaturePerm("BusinessBanking.Payments.Instant Transfer")

        this.state = {
            pmId: this.props.pm ? this.props.pm.id : null,
            paymentMethod: this.props.pm ? this.props.pm.type : instantPaymentsEnabled.manage ? "Instant" : "ACH",
            accountType: this.props.pm ? this.props.pm.bankDetail.accountType : "Checking",
            accountNumber: this.props.pm ? this.props.pm.bankDetail.accountNumber : "",
            routingNumber: this.props.pm ? this.props.pm.bankDetail.routingNumber : "",
            fromAccount: fromAccount && fromAccount,
            checkAddress: this.props.pm ? this.props.pm.bankDetail.bankAddress : null,
            addressOnAccount: this.props.pm ? this.props.pm.bankDetail.addressOnAccount : null,
            createVendorLoading: false,
            vendor: props.vendor,
            loading: false,
            vendorType: (this.props.pm && this.props.pm.vendorType) ? this.props.pm.vendorType : "Business",
            name: this.props.pm && this.props.pm.nickName,
            remittanceInfo: this.props.pm && this.props.pm.remittanceInfo,
            banks: [
                {
                    key: 'aion',
                    name: 'Aion',
                    icon: AionBankIcon,
                },
                {
                    key: 'bofa',
                    name: 'Bank of America',
                    icon: BofAIcon,
                },
                {
                    key: 'chase',
                    name: 'Chase',
                    icon: ChaseIcon,
                },
            ],
        }
    }

    saveInput = (id, dataToSave) => {
        this.setState({ [id]: dataToSave })
    }

    handleAccountSelect = (value, option) => {
        const Accounts = getBPAccountsWithAccess(null, { resourceStr: "Payables.Vendors", permType: "manage", getActiveAccounts: true })
        var fromAccount = Accounts.find(account => account.accountId === value)
        this.setState({ fromAccount })
    }

    handleTextChange = (event) => {
        const target = event.target
        this.saveInput(target.id || target.name, target.value)
        if (event.target.id === "routingNumber") this.setState({ bankLogo: null, instantInstitution: null })
    }

    handleFocusChange = (event) => {
        const { routingNumber, type } = this.state

        if (routingNumber && routingNumber.length < 9) {
            this.setState({ routingNumberError: true })
        }

        if (routingNumber && routingNumber.length === 9) {
            this.setState({ routingNumberError: false })
            const target = event.target
            if (type === "Instant") {
                this.fetchInstantSearchResults(target.value)
            } else {
                this.getInstitutionDetails()
            }
        }
    }

    getLocation = (address, key) => {
        this.setState({ [key]: address })
    }

    getCheckLocation = (location, formattedAddress) => {
        if (!location)
            this.setState({
                checkAddress: {
                    // $set: {
                    line1: null,
                    line2: null,
                    city: null,
                    countrySubDivisionCode: null,
                    state: null,
                    postalCode: null
                    // }
                }
            })
        else
            this.setState({
                checkAddress: {
                    // $set: {
                    line1: location.line1,
                    line2: location.line2,
                    city: location.city,
                    countrySubDivisionCode: location.countrySubDivisionCode,
                    state: location.state,
                    postalCode: location.postalCode
                    // }
                }
            })
    }

    saveACHPayment = (successMessage) => {
        const { returnBody } = this.props
        const { pmId, vendor, vendorType, fromAccount, name, accountNumber, routingNumber, accountType, remittanceInfo } = this.state

        var body = {
            vendorDeliveryMode: 'ACH',
            paymentMethodId: pmId,
            vendorId: vendor.id,
            // accountId: fromAccount.accountId,
            nickName: name,
            vendorType: vendorType,
            bankDetail: {
                vendorDeliveryMode: 'ACH',
                accountName: vendor.vendorName || "",
                accountNumber: accountNumber || "",
                routingNumber: routingNumber || "",
                accountType: accountType || "",
            },
            remittanceInfo: remittanceInfo,
        }

        console.log("saveACHPayment: ", body)

        if (returnBody) {
            this.props.onSave(vendor, body)
        } else {
            apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/addTransferDelivery`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
                this.setState({ createVendorLoading: false })
                try {
                    if (err) throw Error(err)
                    const data = resp || {}
                    if (data.result) {
                        message.success(successMessage)
                        body.type = "ACH"
                        vendor.vendorDeliveryMode = "ACH"
                        this.props.onSave(data.vendor, body)
                    } else {
                        throw Error(data.responseMessage || data.error)
                    }
                } catch (error) {
                    console.log("/createCounterparty err", error, resp, body)
                    ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
                }
                this.setState({ loading: false })
            })
        }
    }

    saveWirePayment = (successMessage) => {
        const { returnBody } = this.props
        const { pmId, vendor, vendorType, fromAccount, name, accountNumber, routingNumber, accountType, remittanceInfo, addressOnAccount } = this.state

        var body = {
            vendorDeliveryMode: 'Wire',
            paymentMethodId: pmId,
            vendorId: vendor.id,
            // accountId: fromAccount.accountId,
            nickName: name,
            vendorType: vendorType,
            bankDetail: {
                vendorDeliveryMode: 'Wire',
                accountName: vendor.vendorName || "",
                accountNumber: accountNumber || "",
                routingNumber: routingNumber || "",
                accountType: accountType || "",
                addressOnAccount: addressOnAccount || {},
            },
            remittanceInfo: remittanceInfo,
        }

        console.log("saveWirePayment: ", body)

        if (returnBody) {
            this.props.onSave(vendor, body)
        } else {
            apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/addTransferDelivery`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
                this.setState({ createVendorLoading: false })
                try {
                    if (err) throw Error(err)
                    const data = resp || {}
                    if (data.result) {
                        message.success(successMessage)
                        body.type = "Wire"
                        vendor.vendorDeliveryMode = "Wire"
                        this.props.onSave(data.vendor, body)
                    } else {
                        throw Error(data.responseMessage || data.error)
                    }
                } catch (error) {
                    console.log("/createCounterparty err", error, resp, body)
                    ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
                }
                this.setState({ loading: false })
            })
        }
    }

    saveInstantPayment = async (successMessage) => {
        const { returnBody } = this.props
        const { pmId, vendor, vendorType, fromAccount, name, accountNumber, routingNumber, accountType, remittanceInfo } = this.state

        var body = {
            vendorDeliveryMode: 'Instant',
            paymentMethodId: pmId,
            vendorId: vendor.id,
            // accountId: fromAccount.accountId,
            nickName: name,
            vendorType: vendorType,
            bankDetail: {
                vendorDeliveryMode: 'Instant',
                accountName: vendor.vendorName || "",
                accountNumber: accountNumber || "",
                routingNumber: routingNumber || "",
                accountType: accountType || "",
            },
            remittanceInfo: remittanceInfo,
        }

        const rtpInstResp = await this.getRTPInstitution()

        if (!rtpInstResp.rtpSupportedInstitution) {
            this.setState({ loading: false, createVendorLoading: false, routingNumberError: true })
            ErrorAlert({ description: rtpInstResp.errorMsg || "This institution does not support instant transfers" })
            return
        }

        console.log("saveInstantPayment: ", body)

        if (returnBody) {
            this.props.onSave(vendor, body)
        } else {
            apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/addTransferDelivery`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
                this.setState({ createVendorLoading: false })
                try {
                    if (err) throw Error(err)
                    const data = resp || {}
                    if (data.result) {
                        console.log("saveInstantPayment: resp", data)
                        message.success(successMessage)
                        body.type = "Instant"
                        vendor.vendorDeliveryMode = "Instant"
                        this.props.onSave(data.vendor, body)
                    } else {
                        throw Error(data.responseMessage || data.error)
                    }
                } catch (error) {
                    console.log("saveInstantPayment err", error, resp, body)
                    ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
                }
                this.setState({ loading: false })
            })
        }
    }

    getRTPInstitution = async () => {
        var body = {
            routingNumber: this.state.routingNumber
        }
        return new Promise((resolve) => {
            this.setState({ loading: true, })
            apiPOSTReq(`${environment.bpBaseUrl}/bp/payments/getRTPDirectory`, {}, body, (err, resp) => {
                try {
                    console.log("/bp/payments/getRTPDirectory", err, resp)
                    const data = resp || {}
                    if (data.results) {
                        resolve({ rtpSupportedInstitution: (data.results.length > 0), rtpInstitution: data.results[0] })
                    } else {
                        throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                    }
                } catch (error) {
                    console.log("ERRR getRTPDirectory", error, err, resp)
                    ErrorAlert({ description: error.message })
                    resolve({ errorMsg: error.message })
                }
            })
        })
    }

    saveCheckPayment = (successMessage) => {
        var { vendor, checkAddress, vendorType, fromAccount, name } = this.state
        var { line1, line2, city, state, postalCode, countrySubDivisionCode } = checkAddress

        var body = {
            vendorDeliveryMode: 'Check',
            pmId: this.state.pmId,
            vendorId: vendor.id,
            accountId: fromAccount.accountId,
            nickName: name,
            vendorType: vendorType,
            bankDetail: {
                bankAddress: {
                    line1: line1,
                    line2: line2,
                    city: city,
                    state: countrySubDivisionCode || state,
                    postalCode: postalCode,
                }
            },
        }

        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/addCheckDelivery`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            console.log("/addCheckDelivery err, resp", err, resp)
            this.setState({ createVendorLoading: false })
            try {
                const data = resp || {}
                if (data.result) {
                    message.success(successMessage)
                    body.type = "Check"
                    vendor.vendorDeliveryMode = "Check"
                    this.props.onSave(vendor, body)
                } else {
                    throw Error(data.error || data.responseMessage)
                }
            } catch (error) {
                console.log("/addCheckDelivery err", error)
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            }
            this.setState({ loading: false })
        })
    }

    handleBankSelect = (bank) => {
        this.setState({ selectedBank: bank, bankName: bank.name, routingNumber: bank.routingNumber })
    }

    savePayment = () => {
        var { pm } = this.props
        var { paymentMethod, accountNumber, routingNumber, checkAddress, fromAccount, name, vendorType, addressOnAccount } = this.state

        if (!name) {
            ErrorAlert({ description: "Please add a nickname." })
            return
        }

        // if (!fromAccount) {
        //     ErrorAlert({ description: "Please select an account." })
        //     return
        // }

        if (["ACH", "Wire", "Instant"].includes(paymentMethod)) {
            if (!routingNumber) {
                ErrorAlert({ description: "Please enter a routing number." })
                return
            }

            if (routingNumber && (isNaN(routingNumber) || routingNumber.length != 9)) {
                ErrorAlert({ description: "Please enter a valid 9-digit routing number." })
                return
            }

            if (!accountNumber) {
                ErrorAlert({ description: "Please enter an account number." })
                return
            }

            if (accountNumber && (isNaN(accountNumber) || accountNumber.length > 17)) {
                ErrorAlert({ description: "Please enter a valid account number. It can have a maximum of 17 characters." })
                return
            }
        } else if (paymentMethod === "Check") {
            if (!checkAddress) {
                ErrorAlert({ description: "Check address is required. Please enter a valid address." })
                return
            }

            var { line1, city, state, postalCode } = checkAddress
            if (!line1 || !city || !state || !postalCode) {
                ErrorAlert({ description: "Check address is required. Please enter a valid address." })
                return
            }
        }

        if (paymentMethod === "Wire") {
            if (!addressOnAccount) {
                ErrorAlert({ description: "Recipient address is required. Please enter a valid address." })
                return
            }

            var { line1, city, state, postalCode } = addressOnAccount
            if (!line1 || !city || !state || !postalCode) {
                ErrorAlert({ description: "Recipient address is required. Please enter a valid address." })
                return
            }
        }

        if (!vendorType) {
            ErrorAlert({ description: "Please select a type for this payment method." })
            return
        }

        this.setState({ loading: true })

        if (paymentMethod === "ACH") {
            this.saveACHPayment(`Payment ${pm ? 'saved' : 'added'} successfully!`)
        } else if (paymentMethod === "Check") {
            this.saveCheckPayment(`Payment ${pm ? 'saved' : 'added'} successfully!`)
        } else if (paymentMethod === "Wire") {
            this.saveWirePayment(`Payment ${pm ? 'saved' : 'added'} successfully!`)
        } else if (paymentMethod === "Instant") {
            this.saveInstantPayment(`Payment ${pm ? 'saved' : 'added'} successfully!`)
        }
    }

    getInstitutionDetails = async () => {
        const { routingNumber } = this.state

        return new Promise((resolve) => {
            const body = { routingNumber };
            // this.setState({ loading: true })
            apiPOSTReq(`${environment.integrationBaseUrl}/integration/plaid/getInstitutionDetails`, {}, body, (err, resp) => {
                try {
                    const data = resp;
                    if (data.result && data.institution) {
                        this.setState({ bankLogo: data.institution.logo, institution: data.institution })
                        resolve(data.institution.logo);
                    } else {
                        throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later");
                    }
                } catch (error) {
                    console.log("ERRR getInstitutionDetails", error.stack, resp);
                    // ErrorAlert({ description: error.message });
                    resolve(null); // resolve with null in case of error
                } finally {
                    this.setState({ searchRTPLoading: false })
                }
            });
        });
    }

    fetchInstantSearchResults = (searchText) => {
        this.setState({ searchRTPLoading: true });
        apiPOSTReq(`${environment.bpBaseUrl}/bp/payments/getRTPDirectory`, {}, { routingNumber: searchText, size: 200 }, (err, resp) => {
            try {
                console.log("AddTransferModal /payments/getRTPDirectory body", { routingNumber: searchText, size: 200 });
                const data = resp || {};
                console.log("AddTransferModal /payments/getRTPDirectory", data);

                if (!data?.results || data?.results.length === 0) this.setState({ routingNumberError: true, searchRTPLoading: false })
                else {
                    this.getInstitutionDetails()
                    this.setState({ routingNumberError: false, instantInstitution: data?.results[0] })
                }
            } catch (error) {
                console.log("AddTransferModal /payments/getRTPDirectory", error, err, resp);
                this.setState({ searchRTPLoading: false })
            } finally {
                console.log('AddTransferModal getRTPDirectory finally')
            }
        })
    };

    render() {
        var { pm, theme } = this.props
        const { name, paymentMethod, accountType, checkAddress, remittanceInfo, aionAccount, loading, vendorType, bankLogo, routingNumber,
            nameError, nameErrorText, addressOnAccount, searchInstantRoutingNumber, searchRTPLoading, instantInstitution, institution } = this.state

        const Accounts = getBPAccountsWithAccess(null, { resourceStr: "Payables.Vendors", permType: "manage", getActiveAccounts: true })

        var accountOptions = []
        var filteredAccounts = Accounts.filter(item => { return (item.accountType !== 'ACCOUNTS_RECEIVABLE') }) || []
        filteredAccounts.forEach(account => {
            accountOptions.push(
                <Option key={account.accountId} value={account.accountId} style={{ backgroundColor: "transparent" }}>
                    <FromAccountOption account={account} />
                </Option>
            )
        })

        var checkPaymentsEnabled = getFeaturePerm("BusinessBanking.Payments.CheckPayment")
        var instantPaymentsEnabled = getFeaturePerm("BusinessBanking.Payments.Instant Transfer")

        var rails = ['ACH', 'Wire']
        if (checkPaymentsEnabled.manage) rails.push('Check')
        if (instantPaymentsEnabled.manage) rails.unshift('Instant')

        return (
            <FlexColumn style={{ width: "100%" }} between>
                <FlexColumn style={{ height: "100%", justifyContent: "flex-start" }} gap='24px'>
                    <Text size='20px'>{pm ? 'Edit' : 'Add'} transfer method</Text>
                    <LabeledInput
                        key="name"
                        inputRef={this.nameRef}
                        label='Nickname'
                        id="name"
                        // type={(addTransfer && transferMethod) && 'read-only'}
                        placeholder="Enter a nickname for this payment method"
                        value={name && name}
                        autoFocus
                        nomargin
                        maxLength={50}
                        onChange={this.handleTextChange}
                        error={nameError}
                        errorMessage={nameErrorText}
                    />

                    {/* <LabeledInput
                        label="From Account"
                        showAction={'focus'}
                        type="select"
                        nomargin
                        key="fromAccount"
                        value={fromAccount && <><img width='16px' height='16px' src={AionIcon} style={{ marginRight: 8, marginBottom: 2 }} /><Text>{`${(fromAccount.nickName || `Business ${fromAccount.accountSubType}`)} • ${fromAccount.mask}`}</Text></>}
                        instruction="We will use this account for your payments to this vendor"
                        placeholder="From account"
                        onChange={this.handleAccountSelect}
                    >
                        {accountOptions}
                    </LabeledInput> */}

                    <div style={{ display: "flex", justifyContent: "space-between", width: 400 }}>
                        <LabeledInput
                            label="Vendor Account Type"
                            type='switch'
                            nomargin
                            switchNames={['Business', 'Individual']}
                            onChange={(value) => this.saveInput("vendorType", value)}
                            value={vendorType} />
                    </div>

                    {
                        (!pm) &&
                        <LabeledInput
                            label='Type'
                            type='switch'
                            nomargin
                            switchNames={rails}
                            onChange={(value) => this.setState({ paymentMethod: value, searchInstantRoutingNumber: false, instantInstitution: null, institution: null })}
                            value={paymentMethod}
                        // error={typeError}
                        // errorMessage='Type is required'
                        />
                    }


                    {paymentMethod === "Wire" && !aionAccount && (
                        <SearchBanks
                            nomargin
                            handleSelect={bank => this.handleBankSelect(bank)}
                        // width='568px'
                        />
                    )}

                    {paymentMethod === "Instant" && searchInstantRoutingNumber === true && !aionAccount && (
                        <FlexColumn start style={{ margin: "0 0 0" }}>
                            <SearchRTPBanks
                                nomargin
                                handleSelect={bank => this.handleBankSelect(bank)}
                                onClear={() => this.setState({ routingNumber: null })}
                            />
                            {
                                (paymentMethod === 'Instant' && searchInstantRoutingNumber) &&
                                <TextButton
                                    text='Enter routing number manually'
                                    weight='400'
                                    onClick={() => this.setState({ searchInstantRoutingNumber: false, routingNumberError: false, routingNumber: null })}
                                />
                            }
                        </FlexColumn>
                    )}

                    {
                        ["Instant", "ACH", "Wire"].includes(paymentMethod) &&
                        <>
                            <FlexColumn start left fullWidth>
                                {
                                    !searchInstantRoutingNumber &&
                                    <LabeledInput
                                        label="Routing Number"
                                        id="routingNumber"
                                        name="routingNumber"
                                        key="routingNumber"
                                        nomargin
                                        value={routingNumber}
                                        placeholder="052001633"
                                        onChange={this.handleTextChange}
                                        onBlur={this.handleFocusChange}
                                        onKeyDown={(event) => { if (event.key === "Enter") this.handleFocusChange(event) }}
                                        maxLength={9}
                                        suffix={searchRTPLoading && <LoadingOutlined style={{ color: theme.colors.primary, fontSize: 16, marginRight: 8 }} />}
                                    />
                                }

                                {
                                    (searchInstantRoutingNumber && routingNumber) &&
                                    <LabeledInput
                                        label="Routing Number"
                                        id="routingNumber"
                                        key="routingNumber"
                                        type='read-only'
                                        value={routingNumber && routingNumber}
                                        width='568px'
                                        nomargin
                                    />
                                }

                                {
                                    (paymentMethod === 'Instant' && !searchInstantRoutingNumber && !instantInstitution) &&
                                    <TextButton
                                        icon={<Image src={Search} />}
                                        text='Find your routing number'
                                        weight='400'
                                        margin='4px 0 0'
                                        onClick={() => this.setState({ searchInstantRoutingNumber: true, routingNumberError: false, routingNumber: null })}
                                    />
                                }

                                {
                                    (paymentMethod === 'Instant' && instantInstitution) &&
                                    <Flex start fullWidth centerHorizontally style={{ marginTop: 8 }} gap='8px'>
                                        {bankLogo && <Image src={bankLogo} />}
                                        <Text size='12px'>{instantInstitution?.name}</Text>
                                    </Flex>
                                }

                                {
                                    (paymentMethod !== 'Instant' && institution) &&
                                    <Flex start fullWidth centerHorizontally style={{ marginTop: 8 }} gap='8px'>
                                        {institution?.logo && <Image src={institution?.logo} />}
                                        <Text size='12px'>{institution?.name}</Text>
                                    </Flex>
                                }
                            </FlexColumn>

                            <LabeledInput
                                autoFocus
                                label="Account Number"
                                name="accountNumber"
                                key="accountNumber"
                                nomargin
                                value={this.state.accountNumber}
                                placeholder="xxxxxxxx"
                                onChange={this.handleTextChange}
                                maxLength={17}
                                instruction="Maximum of 17 characters"
                            />

                            <LabeledInput
                                label="Vendor Bank Account Type"
                                type='switch'
                                nomargin
                                switchNames={['Checking', 'Savings']}
                                onChange={(value) => this.saveInput("accountType", value)}
                                value={upperFirst(accountType)} />
                        </>
                    }

                    {
                        (paymentMethod === 'Wire' || paymentMethod === 'Check') &&
                        <LabeledInput
                            inputRef={this.addressOnAccountRef}
                            label={(paymentMethod === "Check") ? 'Recipient mailing address' : 'Recipient Address'}
                            id="addressOnAccount"
                            key="addressOnAccount"
                            placeholder="Enter Address"
                            tooltip="To avoid failures, verify that this is the address your recipient has registered with their bank. Tip: Request the recipient for a bank letter"
                            nomargin
                            address={addressOnAccount}
                            autoFocus
                            type="location"
                            getLocation={(loc) => this.getLocation(loc, 'addressOnAccount')}
                        // error={addressOnAccountError}
                        // errorMessage="Please enter a valid recipient address"
                        />
                    }

                    {
                        paymentMethod === "Check" &&
                        <LabeledInput
                            id="checkAddress"
                            key="checkAddress"
                            label="Check Address"
                            nomargin
                            type="location"
                            getLocation={this.getCheckLocation}
                            Line2
                            address={checkAddress}
                            value={checkAddress && checkAddress.line1 ?
                                { line1: addressObjectToStr(checkAddress), line2: checkAddress.line2 } : null
                            }
                            placeholder="Address"
                            instruction="We'll mail a check to this address free of cost"
                        />
                    }

                    {
                        <LabeledInput
                            label="Remittance Information"
                            id="remittanceInfo"
                            type="text-area"
                            nomargin
                            placeholder="Save any remittance info to submit along with a transfer"
                            maxLength={80}
                            optional
                            value={remittanceInfo}
                            autoSize={{ minRows: 1, maxRows: 2 }}
                            onChange={this.handleTextChange}
                            instruction={remittanceInfo ? `${remittanceInfo.length}/80` : `0/80`}
                        />
                    }
                </FlexColumn>
                <Flex style={{ width: "100%", marginTop: 24 }} between>
                    <Button noMargin permtype="Payables.Vendors" solid loading={loading} onClick={() => this.savePayment()} text='Submit' />
                </Flex>
            </FlexColumn>
        )
    }
}

function mapStateToProps(state) {
    return {
        bkStore: state.bookkeepingAppReducer,
        aionStore: state.aionAppReducer,
        bankingStore: state.bankingAppReducer,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme(AddPaymentMethod))